import { useTranslation } from 'react-i18next'

import { Button, Modal } from 'common/components'

type ConfirmRenewalBenefitLaunchModalProps = {
  visible: boolean
  onGoBack: () => void
  onConfirmCancel?: () => void
}

const CancelRenewalBenefitNoticeModal = ({
  visible,
  onGoBack,
  onConfirmCancel,
}: ConfirmRenewalBenefitLaunchModalProps) => {
  return (
    <Modal
      onCancel={onGoBack}
      visible={visible}
      title={'Are you sure you want to cancel?'}
      footer={
        <div>
          <Button onClick={onGoBack}>Go back</Button>

          <Button onClick={onConfirmCancel} type="primary" danger={true} className="ml-8">
            Cancel
          </Button>
        </div>
      }
    >
      <div>You haven’t finished completed launching your benefit and inviting your employees.</div>
    </Modal>
  )
}

export default CancelRenewalBenefitNoticeModal
